// Global Instructions Rule Applied!
import { useCallback, useEffect, useState } from 'react'
import { getAccessToken } from '../../../core/auth/authService'
import { store } from '../../../state_manager/store.ts'
import { showErrorToast } from '../../../core/utils/errorToast.tsx'
import { RelationshipFactRecord } from '../../../state_manager/data_models/relationships_model.ts'
import { fetchRelationshipFacts } from '../services/relationshipsService.ts'

export function useRelationshipFacts(
  accountId: string | null | undefined,
  options: { prospectId?: string | null; includeHistory?: boolean } = {}
) {
  const { prospectId = null, includeHistory = false } = options
  const [facts, setFacts] = useState<RelationshipFactRecord[]>([])
  const [loading, setLoading] = useState(false)

  const refetch = useCallback(async () => {
    if (!accountId) {
      setFacts([])
      return
    }
    setLoading(true)
    try {
      setFacts(
        await fetchRelationshipFacts(accountId, { prospectId, includeHistory }, getAccessToken(store.getState().auth))
      )
    } catch (e) {
      showErrorToast(e instanceof Error ? e.message : 'Failed to load relationship facts')
    } finally {
      setLoading(false)
    }
  }, [accountId, prospectId, includeHistory])

  useEffect(() => {
    refetch()
  }, [refetch])

  return { facts, loading, refetch }
}
